import { getHostURL, getImageURL } from '../utils/GeneralUtil';
export var twoWeekInTs = 1209600;
export var currentTs = Date.now() / 1000;
// For icon assets
export var assetsPerks = {
    Card: getImageURL('cardPLCCX.png'),
    CardBanner: getImageURL('banner-bg-PLCC-NotEnrolled.svg'),
    mobileCard: getImageURL('graphic-plccangled.svg'),
    CloseIcon: getImageURL('remove-close_orange.svg'),
    Unlocked: getImageURL('rewards-unlocked-orange.svg'),
    Info: getImageURL('ProTiers/icon-info.svg'),
    Error: getImageURL('warning-yellow.svg'),
    CheckBall: getImageURL('rewards-check-dark.svg'),
    Locked: getImageURL('rewards-locked-dark.svg'),
    UnlockedExpired: getImageURL('rewards-unlocked-expired-dark.svg'),
    BadgUnlocked: getImageURL('badge-unlocked.svg'),
    DefaultPerkIcon: getImageURL('Pro-Xtra_Perk_Icon-whiteFill.svg'),
};
// For Text
export var pkAvailablePerks = {
    subtitle: 'View and redeem your Perks here. You can also manage and redeem them using your Home Depot app. Click on the Perk(s) below for more details.',
    subtitleLine1: ' View and redeem your Perks here. You can also manage and redeem them using your Home Depot app. Click on the',
    subtitleLine2: ' Perk(s) below for more details.',
    subtitleNoPerks: 'View and redeem your Perks here. You can also manage and redeem them using your Home Depot app',
    toolRentalOverlayTitle: 'Tool Rental Perk',
    giftCardDollars: 'Pro Xtra Dollars',
    errorOverlay: ' An error has occured please try again',
    impDetailsGc: 'Important details about your Pro Xtra Dollars:',
    impDetailsTr: 'Important details about your Tool Rental Perk:',
    impDetailsSd: 'Important details about your Bonus Perk:',
    giftCard1: 'Pro Xtra Dollars are Home Depot Digital Reward Cards.',
    giftCard2: ' May be used to purchase merchandise/services at THD stores in U.S. and Canada and online at HomeDepot.com.',
    giftCard3: 'Can be redeemed in-store or online during checkout.',
    giftCard4: 'Not redeemable for cash or credit unless required by law.',
    giftCard5: 'See Pro Xtra Terms and Conditions for additional details',
    gcAndToolRentalLastLine: 'To redeem in-store, access your Perk from the Account section of your profile through The Home Depot app or at homedepot.com on a mobile browser.',
    sdLastLine: ' Access your Bonus Perk from the Account section of your profile through the Home Depot app or at homedepot.com on a mobile browser.',
    bonusExpire: 'Bonus Perk will expire on: ',
    toolRentalLine1: 'Redeemable for rental charges for eligible tools and equipment at',
    toolRentalLine2: 'Expires 12 months after selection.',
    toolRentalLine3: 'To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.',
    toolRentalLine4: ' One Perk per rental contract.',
    toolRentalLine5: '  A Perk may be used once, not redeemable for cash or credit.',
    toolRentalLineEnd: 'in the U.S.',
    scanBarcodeGC: 'Scan barcode and enter the pin below at in store checkout.',
    scanToolRentalBarcode: 'Scan barcode below at in store checkout.',
    onlineCouponHeader: 'Exclusive Online Offer',
    omniCouponHeader: 'Exclusive Online & In-store Offer',
    tsTwoWeeksAge: currentTs - twoWeekInTs,
    sdPerkOverlayHeading1: 'Thank you for your loyalty!',
    giftCard: 'GIFT_CARD',
    toolRental: 'TOOL_RENTAL',
    dayLeftPerk: 'days left to use your Perk',
    spendText: {
        statusPerkExpired: 'We’re Sorry, this Perk has expired.',
        statusCircleUnclock: 'Unlock perks as you spend',
        statusCong: 'Congratulations',
        subHeading: 'Track your progress toward your next Perk. After you have unlocked a Perk, choose which option works for you',
        toolRental: 'Tool Rental',
        perk: 'Perk',
        choose: 'Choose',
        yourPerk: 'your Perk',
        proXtra: 'Pro Xtra',
        dollars: 'Dollars',
        inProgress: 'In progress',
        perkExpired: 'Perk Expired',
        untilThisPerk: 'Until This Perk',
        untilYour: 'Until Your Next Perk',
        nextPerk: 'next Perk',
        youveEarned: 'You’ve unlocked\na new Perk',
        aNewPerk: 'a new perk',
        currentSpend: 'Current Spend',
        in: 'In',
        progress: 'Progress',
        expired: 'Expired',
        toolTipTitle: 'Qualifying Perks Spend',
        toolTipDesc: ' Includes transactions made with Pro Xtra ID or registered tender used at time of checkout. Prior transactions will not be included. Excludes taxes, shipping fees, returns, and gift card purchases.',
    },
    perkText: {
        perkrevealed: 'Perk options revealed once you',
        beginmileston: 'begin this milestone',
        claimBefore: 'Claim before',
        yourPerkOption: 'Your Perk Option',
        youReached: " You've reached",
        spend: 'spend',
        chooseYourPerk: 'Choose Your Perk',
        inSpend: 'in spend',
        youNoUnclaimedperks: ' You have no unclaimed Perks',
        youHave: 'You have',
        unclaimedPerks: 'unclaimed Perks',
    },
    statusCircleUnlock: 'Unlock perks as you spend',
    statusCong: 'Congratulations',
    subHeading: 'Track your progress toward your net Perk. After you have unlocked a Perk, choose which option works for you',
    perk: 'Perk',
    choose: 'Choose',
    yourPerk: 'your Perk',
    proXtra: 'Pro Xtra',
    dollars: 'Dollars',
    inProgress: 'In progress',
    perkExpired: 'Perk Expired',
    untilThisPerk: 'Until this perk',
    untilYour: 'until your',
    nextPerk: 'next Perk',
    youveEarned: "You've earned",
    aNewPerk: 'a new perk',
    currentSpendText: 'Current Spend',
    in: 'In',
    progress: 'Progress',
    expired: 'Expired',
    perkRevealed: 'Perk options revealed once you',
    beginMilestone: 'begin this milestone',
    claimBefore: 'Claim before',
    choosePerkBy: 'Choose Perk by',
    yourPerkOption: 'Your Perk Option',
    youReached: "You've reached",
    spend: 'spend',
    chooseYourPerk: 'Choose Your Perk',
    inSpend: 'in spend',
    youNoUnclaimedPerks: ' You have no unclaimed Perks',
    youHave: 'You have',
    unclaimedPerks: 'unclaimed Perks',
    currentSpendBox: 'Qualifying Perks Spend Includes transactions made with Pro Xtra ID or registered tender used at time of checkout. Prior transactions will not be included. Excludes taxes, shipping fees, returns, and gift card purchases.',
    starSubTotal: ' *Sub-totals may not appear to add correctly because of rounding',
    howAccelerate: 'How To Accelerate Perks Spend',
    spendNeeded: 'Spend Needed to Unlock Next Perk:',
    moreBenefits: 'Additional Pro Xtra Credit Card Benefits',
    plccModelTooltipQualifying: 'Qualifying Perks Spend',
    plccModelTooltip: ' Includes transactions made with Pro Xtra ID or registered tender used at time of checkout. Prior transactions will not be included. Excludes taxes, shipping fees, returns, and gift card purchases.',
    qualifyingSpend: 'Qualifying Spend',
    perkSpend: 'Perks Spend',
    bonus: 'Bonus',
    plccAccelerateDesc1: 'The Pro Xtra Credit Card earns',
    plccAccelerateDesc2: 'every dollar spent at The Home Depot towards Perks.',
    applyNowPlcc: 'https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action?app=UNSOL&siteId=PLCR_HOMEDEPOT&sc=40012&cmp=A~E~Z~O~3~B~ZZZ0~CR~HD~ZZ_C3T',
    benefitsListState: [
        {
            BenefitsList: 'Payment flexibility: Make low monthly payments or pay in full',
        },
        {
            BenefitsList: 'Authorized-user cards available ',
        },
        {
            BenefitsList: 'Track purchases by PO or job name',
        },
        {
            BenefitsList: 'Itemized statements',
        },
        {
            BenefitsList: 'One-year return policy',
        },
    ],
};
export var pkPerkHistory = {};
export var pkPerkProgress = {
    rewardsHubURL: getHostURL('myaccount/proXtraRewards'),
    perkSpendDescription: "Track your progress toward your next Perk. Once you reach the spend level, select a Perk option.",
    AvailableSubtitle: "View and redeem your Perks here. You can also manage and redeem them using your Home Depot app. Click on the Perk(s) below for more details.",
    AvailableSubtitleLine1: " View and redeem your Perks here. You can also manage and redeem them using your Home Depot app. Click on the",
    AvailableSubtitleNoPerks: "View and redeem your Perks here. You can also manage and redeem them using your Home Depot app",
    AvailableSubtitleLine2: " Perk(s) below for more details.",
    ToolRentalOverlayTitle: "Tool Rental Perk",
    giftcardDollars: "Pro Xtra Dollars",
    // overlays
    errorMessage: " An error has occured please try again",
    impDetailsGc: "Important details about your Pro Xtra Dollars:",
    impDetailsTr: "Important details about your Tool Rental Perk:",
    imDetailsSd: "Important details about your Bonus Perk:",
    giftcard1: "Pro Xtra Dollars are Home Depot Digital Reward Cards.",
    giftcard2: " May be used to purchase merchandise/services at THD stores in U.S. and Canada and online at HomeDepot.com.",
    giftcard3: "Can be redeemed in-store or online during checkout.",
    giftcard4: "Not redeemable for cash or credit unless required by law.",
    giftcard5: "See Pro Xtra Terms and Conditions for additional details",
    gcAndToolRentalLastLine: "To redeem in-store, access your Perk from the Account section of your profile through The Home Depot app or at homedepot.com on a mobile browser.",
    sdLastLine: " Access your Bonus Perk from the Account section of your profile through the Home Depot app or at homedepot.com on a mobile browser.",
    // sd
    bonusExpire: "Bonus Perk will expire on: ",
    // Tool Rental
    toolRentalLine1: "Redeemable for rental charges for eligible tools and equipment at",
    toolRentalLine2: "Expires 12 months after selection.",
    toolRentalLine3: "To redeem, present valid Pro Xtra ID number and Perk barcode from The Home Depot mobile app.",
    toolRentalLine4: " One Perk per rental contract.",
    toolRentalLine5: "  A Perk may be used once, not redeemable for cash or credit.",
    toolRentalLineEnd: "in the U.S.",
    // Mobile Overlays:
    scanBarcodeGC: "Scan barcode and enter the pin below at in store checkout.",
    scanToolRentalBarcode: "Scan barcode below at in store checkout.",
    OnlineCouponHeader: "Exclusive Online Offer",
    OmniCouponHeader: "Exclusive Online & In-store Offer",
    twoWeekInTs: 1209600,
    currentTs: Date.now() / 1000,
    tsTwoWeeksAgo: currentTs - twoWeekInTs,
    sdPerkOverlayHeading1: "Thank you for your loyalty!",
    giftCard: "GIFT_CARD",
    toolRental: "TOOL_RENTAL",
    dayLeftperk: "days left to use your Perk",
    spendText: {
        statusPerkExpired: "We're Sorry, this Perk has Expired.",
        statusCircleUnclock: "Unlock Perks as You Spend",
        statusCong: "Congratulations",
        subHeading: "Track your progress toward your next Perk. After you have unlocked a Perk, choose which option works for you",
        toolRental: "Tool Rental",
        perk: "Perk",
        choose: "Choose",
        yourPerk: "Your Perk",
        proXtra: "Pro Xtra",
        dollars: "Dollars",
        inProgress: "In Progress",
        perkExpired: "Perk Expired",
        untilThisPerk: "Until This Perk",
        untilYour: "Until Your\nNext Perk",
        nextPerk: "Next Perk",
        youveEarned: "You've Unlocked\nA New Perk",
        aNewPerk: "a new perk",
        currentSpend: "Current Spend",
        in: "In",
        progress: "Progress",
        expired: "Expired",
        toolTipTitle: "Qualifying Perks Spend",
        toolTipDesc: " Includes transactions made with Pro Xtra ID or registered tender used at time of checkout. Prior transactions will not be included. Excludes taxes, shipping fees, returns, and gift card purchases.",
    },
    perkText: {
        perkrevealed: "Perk options revealed once you",
        beginmileston: "begin this milestone",
        claimBefore: "Claim before",
        yourPerkOption: "Your Perk Option",
        youReached: " You've reached",
        spend: "spend",
        chooseYourPerk: "Choose Your Perk",
        inSpend: "in spend",
        youNoUnclaimedperks: " You have no unclaimed Perks",
        youHave: "You have",
        unclaimedPerks: "unclaimed Perks",
    },
    statusCircleUnclock: "Unlock Perks as You Spend",
    statusCong: "Congratulations",
    subHeading: "Track your progress toward your next Perk. After you have unlocked a Perk, choose which option works for you",
    perk: "Perk",
    choose: "Choose",
    yourPerk: "your Perk",
    proXtra: "Pro Xtra",
    dollars: "Dollars",
    inProgress: "In progress",
    perkExpired: "Perk Expired",
    untilThisPerk: "Until this perk",
    untilYour: "until your",
    nextPerk: "next Perk",
    youveEarned: "You've earned",
    aNewPerk: "a new perk",
    currentSpend: "Current Spend",
    In: "In",
    progress: "Progress",
    expired: "Expired",
    perkrevealed: "Perk options revealed once you",
    beginmileston: "begin this milestone",
    claimBefore: "Claim before",
    choosePerkBy: "Choose Perk by",
    yourPerkOption: "Your Perk Option",
    youReached: " You've reached",
    spend: "spend",
    chooseYourPerk: "Choose Your Perk",
    inSpend: "in spend",
    youNoUnclaimedperks: " You have no unclaimed Perks",
    youHave: "You have",
    unclaimedPerks: "unclaimed Perks",
    currentSpendBox: "Qualifying Perks Spend Includes transactions made with Pro Xtra ID or registered tender used at time of checkout. Prior transactions will not be included. Excludes taxes, shipping fees, returns, and gift card purchases.",
    starSubTotal: " *Sub-totals may not appear to add correctly because of rounding",
    howAccelerate: "How To Accelerate Perks Spend",
    spendNeeded: "Spend Needed to Unlock Next Perk:",
    moreBenefits: "Additional Pro Xtra Credit Card Benefits",
    plccModelTooltipQualifying: "Qualifying Perks Spend",
    plccModelTooltip: " Includes transactions made with Pro Xtra ID or registered tender used at time of checkout. Prior transactions will not be included. Excludes taxes, shipping fees, returns, and gift card purchases.",
    QualifyingSpend: "Qualifying Spend",
    perkSpend: "Perks Spend",
    bonus: "Bonus",
    plccAccelerateDesc1: "The Pro Xtra Credit Card earns",
    plccAccelerateDesc2: "every dollar spent at The Home Depot towards Perks.",
    applyNowPlcc: "https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action?app=UNSOL&siteId=PLCR_HOMEDEPOT&sc=40012&cmp=A~E~Z~O~3~B~ZZZ0~CR~HD~ZZ_C3T",
    BenefitsListState: [
        {
            BenefitsList: "Payment flexibility: Make low monthly payments or pay in full",
        },
        {
            BenefitsList: "Authorized-user cards available ",
        },
        {
            BenefitsList: "Track purchases by PO or job name",
        },
        {
            BenefitsList: "Itemized statements",
        },
        {
            BenefitsList: "One-year return policy",
        },
    ],
};
export var pkPerkBanner = {
    bannerPerkTextMobile: 'Spend. Unlock. Choose.',
    bannerPerkTextMobile2: 'Earning Perks is Simple.',
    recentActiveHeading: 'Introducing Pro Xtra Perks',
    recentActiveText: "Your purchases now through the end of the year are eligible towards this year's Perks Spend. Scan your Pro Xtra Virtual ID from the Mobile App or login to your online account to earn rewards.",
    recentActiveTextHDPass: "Your purchases now through the end of the year are eligible towards this year's Perks Spend. Scan your Pro Xtra HD Pass from the Mobile App or login to your online account to earn rewards.",
    recentActiveMobileText: 'Scan your Pro Xtra Virtual ID from the Mobile App or login to your online account at checkout to earn rewards.',
    recentActiveMobileTextHDPass: 'Scan your Pro Xtra HD Pass from the Mobile App or login to your online account at checkout to earn rewards.',
    previousYearForBannerDisplay1: 'Choose your remaining unlocked Perks from',
    previousYearForBannerDisplay2: 'Once chosen, they can be accessed in the Available Perks section.',
    bannerData: [
        {
            id: 1,
            heading: 'Spend',
            description: 'Spend with Pro Xtra to earn perks.',
        },
        {
            id: 2,
            heading: 'Unlock',
            description: 'Unlock new perks as you spend more. ',
        },
        {
            id: 3,
            heading: 'Choose',
            description: 'Choose the perk that works for you.',
        },
    ],
};
export var pkPLCCBanner = {
    plccModalTooltipQualifying: 'Qualifying Perks Spend',
    plccModalTooltip: 'Includes transactions made with Pro Xtra ID or registered tender used at time of checkout. Prior transactions will not be included. Excludes taxes, shipping fees, returns, and gift card purchases.',
    plccModalTitle: 'Includes Pro Xtra Credit Card Spend',
    plccModalTitle2: 'Earn Perks 4x Faster with the Pro Xtra Credit Card',
    plccModalTitle2SubText: 'The Pro Xtra Credit Card earns 4X every dollar spent at The Home Depot towards Perks.',
    applyNowPlcc: 'https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action?app=UNSOL&siteId=PLCR_HOMEDEPOT&sc=40012&cmp=A~E~Z~O~3~B~ZZZ0~CR~HD~ZZ_C3T',
    QualifyingSpend: 'Qualifying Spend',
    bonus: 'Bonus',
    perkSpend: 'Perks Spend',
    starSubTotal: ' *Sub-totals may not appear to add correctly because of rounding',
    howAccelerate: 'How To Accelerate Perks Spend',
    plccAccelerateDesc1: 'The Pro Xtra Credit Card earns',
    plccAccelerateDesc2: 'every dollar spent at The Home Depot towards Perks.',
    spendNeeded: 'Spend Remaining until Next Perk:',
    moreBenefits: 'Additional Pro Xtra Credit Card Benefits',
    plccCardMember: 'Pro Xtra Credit Card Member',
    plccCardL: 'Pro Xtra Credit Card',
    plccCardS: 'Pro Xtra Card:',
    BenefitsListState: [
        {
            BenefitsList: 'Payment flexibility: Make low monthly payments or pay in full',
        },
        {
            BenefitsList: 'Authorized-user cards available',
        },
        {
            BenefitsList: 'Track purchases by PO or job name',
        },
        {
            BenefitsList: 'Itemized statements',
        },
        {
            BenefitsList: "One-year return policy",
        },
    ],
};
